import React, { useEffect, useRef } from "react";
import "../../../styles/utils/loading/MagicLoading.scss";
import { useRive } from "@rive-app/react-canvas";
import { useSoundContext } from "../../../SoundContext";
import MusicToggleButton from "../../utils/button/MusicToggleButton";
import { getLocalizedAssetPath } from "../../../utils/getLocalizedLogo";

export default function MagicLoading() {
  const { isMuted } = useSoundContext();
  const audioRef = useRef(null);

  useEffect(() => {
    const audio = new Audio("/audio/customBook/loading-music.mp3");
    audio.loop = true;
    audio.volume = 0.5;
    audioRef.current = audio;

    if (!isMuted) {
      audio.play().catch((err) => console.log("Audio play failed:", err));
    }

    return () => {
      audio.pause();
      audioRef.current = null;
    };
  }, []);

  useEffect(() => {
    if (audioRef.current) {
      if (isMuted) {
        audioRef.current.pause();
      } else {
        audioRef.current
          .play()
          .catch((err) => console.log("Audio play failed:", err));
      }
    }
  }, [isMuted]);
  const { RiveComponent: Nikki } = useRive({
    src: "/images/utils/loading/magicLoading/flying-nikki.riv",
    autoplay: true,
  });
  const { RiveComponent: Arial } = useRive({
    src: "/images/utils/loading/magicLoading/flying-arial.riv",
    autoplay: true,
  });

  return (
    <div className="magic-loading-overlay">
      <div className="music-toggle-btn-magic-wrapper">
        <MusicToggleButton />
      </div>
      <div className="magic-loading-content">
        <div className="magic-loading-character-left">
          <Arial />
        </div>
        <div className="magic-loading-character-right">
          <Nikki />
        </div>
        <figure className="magic-loading-spotlight">
          <img
            src="/images/utils/loading/magicLoading/spotlight.svg"
            alt="스포트라이트"
          />
        </figure>
        <figure className="magic-loading-banner">
          <img
            src={getLocalizedAssetPath("/images/utils/loading/magicLoading/title.svg")}
            alt="마법같은 동화가 곧 완성돼요!"
          />
        </figure>
        <figure className="magic-loading-main-text">
          <img
            src="/images/utils/loading/magicLoading/coming-soon.svg"
            alt="마법 같은 장면을 준비 중이에요!"
          />
        </figure>
        <figure className="magic-loading-books">
          <img
            src="/images/utils/loading/magicLoading/book.svg"
            alt="책 더미"
          />
        </figure>
        <figure className="magic-loading-asset1">
          <img
            src="/images/utils/loading/magicLoading/asset1.svg"
            alt="책 더미"
          />
        </figure>
        <figure className="magic-loading-asset2">
          <img
            src="/images/utils/loading/magicLoading/asset2.svg"
            alt="책 더미"
          />
        </figure>
        <figure className="magic-loading-asset3">
          <img
            src="/images/utils/loading/magicLoading/asset3.svg"
            alt="책 더미"
          />
        </figure>
      </div>
    </div>
  );
}
